export const FETCH_ADMIN_DASHBOARD_EVENTS_BEGIN = 'FETCH_ADMIN_DASHBOARD_EVENTS_BEGIN';
export const FETCH_ADMIN_DASHBOARD_EVENTS_ERROR = 'FETCH_ADMIN_DASHBOARD_EVENTS_ERROR';
export const FETCH_ADMIN_DASHBOARD_EVENTS_SUCCESS = 'FETCH_ADMIN_DASHBOARD_EVENTS_SUCCESS';

export const DELETE_EVENT_BEGIN = 'DELETE_EVENT_BEGIN';
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const CLEAR_EVENT_DELETE_STATUS = 'CLEAR_EVENT_DELETE_STATUS';
